<section class="top-half">
    <div class="brand">
        <div class="logos">
            <a target="_blank" href="https://www.gov.br/pt-br">
                <img class="govbr" src="/svg/govbr-logo-large-1.svg" alt="gov.br" />
            </a>
            <div class="divisor"></div>
            <a target="_self" href="/">
                <img src="/svg/project-logos/logotype-xl-gradient.svg" alt="Docentes do Brasil" />
            </a>
        </div>
        <div class="contato">
            <div class="redes">
                <a>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
                    </svg>
                </a>
                <a>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
                        <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        <path d="M16.5 7.5l0 .01" />
                    </svg>
                </a>
                <a>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z" />
                        <path d="M10 9l5 3l-5 3z" />
                    </svg>
                </a>
            </div>

            <a class="body4 regular email">email&#64;email.com</a>
        </div>
    </div>

    <nav>
        <ul>
            <em class="body3 medium">Explore</em>
            <li>
                <a routerLink="painel-indicadores" routerLinkActive="active" class="body3 regular"
                    >indicadores de condições de trabalho docente</a
                >
            </li>
        </ul>
    </nav>
    <nav>
        <ul>
            <em class="body3 medium">Outras consultas</em>
            <li>
                <a routerLink="paineis-analiticos/mapas" routerLinkActive="active" class="body3 regular">mapas</a>
            </li>
            <li>
                <a routerLink="paineis-analiticos/dispersao" routerLinkActive="active" class="body3 regular"
                    >gráficos</a
                >
            </li>
            <li>
                <a routerLink="bases-de-dados" routerLinkActive="active" class="body3 regular">bases de dados</a>
            </li>
        </ul>
    </nav>
    <nav>
        <ul>
            <em class="body3 medium">Conheça</em>
            <li>
                <a routerLink="sobre" routerLinkActive="active" class="body3 regular">sobre</a>
            </li>
            <li>
                <a appFichaTecnica href="#" class="body3 regular">fichas técnicas</a>
            </li>
            <li><a class="body3 regular">mapa do site</a></li>
        </ul>
    </nav>
</section>
<section>
    <div class="greetings">
        <div>
            <p class="body2 bold">Realização</p>
            <div class="logos-desenvolvimento">
                <!-- <div class="agrupamento">
                    <a target="_blank" href="https://www.gov.br/mec/pt-br">
                        <img
                            class="logo-mec"
                            src="/svg/logos-footer/mec-color.png"
                            alt="Ministério da Educação - Governo Federal"
                        />
                    </a>
                </div> -->
                <div class="agrupamento">
                    <a target="_blank" href="https://dadoseducacionaishom.c3sl.ufpr.br/">
                        <img src="/svg/logos-footer/lde-color.svg" alt="Laboratório de Dados Educacionais" />
                    </a>
                    <a target="_blank" href="https://fabrica.inf.ufg.br">
                        <img src="/svg/logos-footer/fs-color.png" alt="Fábrica de Software" />
                    </a>
                    <a target="_blank" href="https://ufg.br/">
                        <img src="/svg/logos-footer/ufg-color.png" alt="Universidade Federal de Goiás" />
                    </a>
                    <a target="_blank" href="https://ufpr.br/">
                        <img src="/svg/logos-footer/ufpr-color.png" alt="Universidade Federal do Paraná" />
                    </a>
                    <a target="_blank" href="https://www5.usp.br/">
                        <img src="/svg/logos-footer/usp.png" alt="Universidade de São Paulo" />
                    </a>
                </div>
            </div>
        </div>
        <div>
            <p class="body2 bold">Apoios</p>
            <div class="logos-apoio">
                <a target="_blank" href="https://lamcad.ufg.br/">
                    <img
                        src="/svg/logos-footer/lamcad.png"
                        alt="Laboratório de Computação Avançada do Brasil Central"
                    />
                </a>
                <a target="_blank" href="https://site.funape.org.br/">
                    <img src="/svg/logos-footer/funape.png" alt="Fundação de Apoio à Pesquisa" />
                </a>
            </div>
        </div>
    </div>
</section>
<section class="copyright">
    <small class="body5 regular">
        ©2024 - {{ currentYear }} &nbsp;&nbsp; Docentes do Brasil, Ministério da Educação
        <strong class="body5 bold"
            >&nbsp;&nbsp; • &nbsp;&nbsp;Ícones por
            <a href="https://tabler.io/icons" target="_blank">Tabler Icons</a></strong
        >
    </small>
</section>
